import { render, staticRenderFns } from "./Operai.vue?vue&type=template&id=653b481f&scoped=true&"
import script from "./Operai.vue?vue&type=script&lang=js&"
export * from "./Operai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b481f",
  null
  
)

export default component.exports